var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -2.5 18 22.5",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,6 C10.672,6 10,5.328 10,4.5 C10,3.672 10.672,3 11.5,3 C12.328,3 13,3.672 13,4.5 C13,5.328 12.328,6 11.5,6 M6.5,7 C5.672,7 5,6.328 5,5.5 C5,4.672 5.672,4 6.5,4 C7.328,4 8,4.672 8,5.5 C8,6.328 7.328,7 6.5,7 M4.5,12 C3.672,12 3,11.328 3,10.5 C3,9.672 3.672,9 4.5,9 C5.328,9 6,9.672 6,10.5 C6,11.328 5.328,12 4.5,12 M9,0 C4.029,0 0,4.029 0,9 C0,13.971 4.029,18 9,18 C9.302,18 9.601,17.984 9.895,17.955 C9.907,17.954 9.92,17.953 9.932,17.952 C10.938,17.848 11.888,17.569 12.766,17.16 C13.362,16.862 13.673,16.515 13.83,16.201 C13.964,15.923 13.927,15.6 13.881,15.39 C13.866,15.337 13.861,15.274 13.842,15.225 C13.838,15.21 13.829,15.181 13.829,15.181 C13.366,14.038 12,14 12,14 C12,14 10,13.969 10,12 C10,10.031 12,10 12,10 L16,10 C16,10 17.937,10 17.937,8.042 C17.937,8.02 17.939,8.004 17.939,7.983 C17.433,3.492 13.626,0 9,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.153077a7.svg";
export { ForwardRef as ReactComponent };